module.exports = __webpack_public_path__ + "img/dessert.7287ff41.png";